// extracted by mini-css-extract-plugin
export default {"navbarLogo":"NavbarLogo_navbarLogo__BJcee","logoContainer":"NavbarLogo_logoContainer__qejFM"};